import React, { useEffect, useState } from 'react';
import { auth, identityAuth, isIdentityIntegrationEnabled } from '../firebase';
import { GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { signInFreshmeetAfterIdentity } from '../utils/identityFreshmeetBridge';

const AdminLogin = ({ redirectTo = '/admin', title = 'Admin Login' }) => {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [emailLoading, setEmailLoading] = useState(false);
  const useIdentity = isIdentityIntegrationEnabled() && identityAuth;

  useEffect(() => {
    if (!loading && user) {
      navigate(redirectTo, { replace: true });
    }
  }, [user, loading, navigate, redirectTo]);

  const provider = new GoogleAuthProvider();

  const handleGoogleSignIn = async () => {
    setEmailError('');
    setEmailLoading(true);
    try {
      if (useIdentity) {
        await signInWithPopup(identityAuth, provider);
        await signInFreshmeetAfterIdentity();
      } else {
        await signInWithPopup(auth, provider);
      }
      navigate(redirectTo);
    } catch (err) {
      console.error('Google Sign In Error:', err);
      setEmailError(err.message || 'Sign in failed.');
    } finally {
      setEmailLoading(false);
    }
  };

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    setEmailError('');
    setEmailLoading(true);
    try {
      if (useIdentity) {
        await signInWithEmailAndPassword(identityAuth, email.trim(), password);
        await signInFreshmeetAfterIdentity();
      } else {
        await signInWithEmailAndPassword(auth, email.trim(), password);
        await auth.currentUser?.getIdToken(true);
      }
      navigate(redirectTo);
    } catch (err) {
      setEmailError(err.message || 'Sign in failed.');
    } finally {
      setEmailLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: '40px auto', padding: 24 }}>
      <h2>{title}</h2>
      {useIdentity && (
        <p style={{ fontSize: 14, marginBottom: 16 }}>
          Sign in with your Fury Identity account. You will be connected to this app automatically.
        </p>
      )}
      <button
        type="button"
        onClick={handleGoogleSignIn}
        disabled={emailLoading}
        style={{ display: 'block', marginBottom: 24, padding: '10px 16px' }}
      >
        Sign in with Google
      </button>
      <p style={{ marginBottom: 8, fontSize: 14 }}>
        {useIdentity
          ? 'Or sign in with email and password from your Identity account:'
          : 'Or sign in with email and password from your Identity account:'}
      </p>
      <form onSubmit={handleEmailSignIn}>
        {emailError && <p style={{ color: 'red', fontSize: 14 }}>{emailError}</p>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', marginBottom: 4 }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%', padding: 8, boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 4 }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: '100%', padding: 8, boxSizing: 'border-box' }}
          />
        </div>
        <button type="submit" className="btn-fm-primary" disabled={emailLoading}>
          {emailLoading ? 'Signing in…' : 'Sign in with email'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
